var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramRenovations64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./Renovations64*",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Renovations",
    transform: "translate(6.000000, 17.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8965517,17 L26.5,17 C28.5046359,17 20.862069,17 20.862069,17 C19.2068966,16.744186 17.5517241,15.0697674 17.5517241,13.3953488 L17.5517241,12 C17.5517241,9.28139951 17.5517241,3.34883721 17.5517241,3.34883721 C17.5517241,1.6744186 19.2068966,0 20.862069,0 L39.8965517,0 C45.6896552,0 49.0000007,3 49,9 C49.0000007,14 45.6896552,16.744186 39.8965517,17 Z",
    id: "Body",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,17 L26.4708029,17 C28.5924978,17 20.5036496,17 20.5036496,17 C18.7518248,16.744186 17,15.0697674 17,13.3953488 L17,12 C17,9.28139951 17,3.34883721 17,3.34883721 C17,1.6744186 18.7518248,0 20.5036496,0 L27,0 L27,17 Z",
    id: "Focus",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Nose",
    fill: "#FFFFFF",
    points: "11 13 17.5 13 17.5 3 11 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,8 L11,8",
    id: "Drill-Bit",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Triger",
    strokeLinejoin: "round",
    points: "27 16.5 27 22 33 22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,35 L38,35",
    id: "Base",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Handle",
    fill: "#FFFFFF",
    points: "37 35 32 17 38 17 43 35"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramRenovations64);
export default __webpack_public_path__ + "static/media/pictogramRenovations64.7a96c6692024b96f635ac7cb2c96141f.svg";
export { ForwardRef as ReactComponent };